<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-11-16 10:48:19
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-14 09:40:57
-->
<template>
  <!-- color="blue-grey lighten-2" -->
  <div style="position: relative">
    <div style="position: absolute; top: -7px" v-if="propertylist">
      <span
        :class="[
          color && Array.isArray(errorMessages) && errorMessages.length <= 0
            ? 'primary--text'
            : '',
        ]"
        :style="{
          'font-size': '12px',
          color:
            Array.isArray(errorMessages) && errorMessages.length > 0
              ? 'red'
              : '',
        }"
      >
        {{ label }}
      </span>
    </div>
    <!--  :menu-props="{
        closeOnClick: false,
        closeOnContentClick: false,
        disableKeys: true,
        openOnClick: false,
        maxHeight: maxHeight,
      }" -->
    <v-autocomplete
      v-model="uuid"
      class="autoocomplete"
      :readonly="readonly"
      :items="selectList"
      :label="propertylist ? '' : label"
      :placeholder="
        placeholder
          ? removestar(placeholder)
          : readonly
          ? ' '
          : removestar(label)
      "
      @change="change"
      :errorMessages="errorMessages"
      @blur="blur"
      @focus="focus"
      :multiple="multiple"
      style="min-height: 40px"
      :background-color="
        backgroundColor ? backgroundColor : readonly ? '#fff' : '#f5f5f5'
      "
      color="primary"
      :append-icon="readonly ? '' : 'arrow_drop_down'"
      :filter="filterMethod"
      :item-text="itemText"
      :item-value="itemValue"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-slot:no-data>
        <mrc_ess_noContent
          height="50"
          type="2"
          svgFontSize="50"
          :no_data_text="$t('label_blank')"
        />
      </template>

      <template v-slot:prepend-inner>
        <div class="d-flex align-center">
          <v-chip
            v-for="(item, index) in propertylist"
            :key="index"
            @click:close="closeChipProperty(item, index)"
            :close="!readonly"
          >
            {{ item[propertyKey] }}
          </v-chip>
        </div>
      </template>
      <!-- @click="allcheck" -->
      <!-- <template v-slot:prepend-item>
        <v-list-item tabindex='0'
                     ripple
                     @click="allcheck"
                     v-if="multiple"
                     style="height:48px">
          <v-checkbox> </v-checkbox>
          {{$t('label_select_all')}}
        </v-list-item>
      </template> -->

      <template v-slot:selection="data">
        <!-- 多选 -->
        <div v-if="multiple">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            :close="!readonly"
            @click="data.select"
            @click:close="remove(data.item)"
          >
            <slot :item="data.item">
              <!-- Math.round(Math.random() * (colorArr.length - 1)) -->
              <v-avatar
                left
                size="24"
                style="border: 1px solid rgba(0, 0, 0, 0.1)"
                :color="colorArr[data.item.colorId]"
              >
                <v-img
                  :src="getImgSrc(data.item.staff_avatar)"
                  v-if="getImgSrc(data.item.staff_avatar)"
                >
                  <template v-slot:placeholder>
                    <v-progress-circular
                      :size="24"
                      :width="2"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </template>
                </v-img>
                <span
                  v-else
                  style="
                    font-size: 14px;
                    text-transform: uppercase;
                    color: #ffffff;
                  "
                >
                  {{
                    INT(data.item[itemText])
                      ? INT(data.item[itemText]).substr(0, 1)
                      : ""
                  }}
                </span>
              </v-avatar>
              <span>
                {{ INT(data.item[itemText]) }}
                <span class="text--secondary">
                  {{
                    INT(data.item[staffCode])
                      ? "(" + INT(data.item[staffCode]) + ")"
                      : ""
                  }}
                </span>
              </span>
            </slot>
          </v-chip>
        </div>
        <!-- 单选 -->
        <div v-else class="d-flex align-center">
          <slot :item="data.item">
            <div class="pr-3">
              <v-avatar
                size="24"
                style="border: 1px solid rgba(0, 0, 0, 0.1)"
                :color="colorArr[data.item.colorId]"
              >
                <v-img
                  v-if="getImgSrc(data.item.staff_avatar)"
                  :src="getImgSrc(data.item.staff_avatar)"
                >
                  <template v-slot:placeholder>
                    <v-progress-circular
                      :size="24"
                      :width="2"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </template>
                </v-img>
                <span
                  v-else
                  style="
                    font-size: 14px;
                    text-transform: uppercase;
                    color: #ffffff;
                  "
                >
                  {{
                    INT(data.item[itemText])
                      ? INT(data.item[itemText]).substr(0, 1)
                      : ""
                  }}
                </span>
              </v-avatar>
            </div>
            <div>
              <div>
                {{ INT(data.item[itemText]) }}
                <span class="text--secondary">
                  {{
                    INT(data.item[staffCode])
                      ? "(" + INT(data.item[staffCode]) + ")"
                      : ""
                  }}
                </span>
              </div>
              <!-- <div v-if="data.item[job_grade_name]||data.item[job_post_name]||data.item[client_name]||data.item[org_level_name]||data.item[dept_name]">
                <span style="font-size: 12px;color: rgba(0, 0, 0, 0.38)">
                  {{ INT(data.item[job_post_name]) }}
                  {{
                    INT(data.item[job_grade_name])
                      ? '(' + INT(data.item[job_grade_name]) + ')'
                      : ''
                  }}
                </span>
                <span class="mx-2"></span>
                <span style="font-size: 12px;color: rgba(0, 0, 0, 0.38)">
                  {{ INT(data.item[client_name])
                  }}{{
                    INT(data.item[org_level_name])
                      ? '>' + INT(data.item[org_level_name])
                      : '' | replaceclient_and_org
                  }}{{
                    INT(data.item[dept_name])
                      ? '>' + INT(data.item[dept_name])
                      : '' | replaceclient_and_org
                  }}
                </span>
              </div> -->
            </div>
          </slot>
        </div>
      </template>

      <!-- 下拉列表 -->
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content
            v-text="data.item"
            class="pa-0"
          ></v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-content
            class="pa-0"
            style="height: 48px"
            v-if="!data.item.allcheck"
          >
            <div class="d-flex align-center px-4" style="height: 48px">
              <!-- 复选框 -->
              <v-checkbox
                v-if="multiple"
                class="pt-6"
                v-model="data.attrs.inputValue"
              >
              </v-checkbox>
              <!-- 头像 -->
              <v-avatar
                class="mr-2"
                size="32"
                style="border: 1px solid rgba(0, 0, 0, 0.1)"
                :color="colorArr[data.item.colorId]"
              >
                <img
                  v-if="getImgSrc(data.item.staff_avatar)"
                  :src="getImgSrc(data.item.staff_avatar)"
                />
                <span
                  v-else
                  style="
                    font-size: 19px;
                    text-transform: uppercase;
                    color: #ffffff;
                  "
                >
                  {{
                    INT(data.item[itemText])
                      ? INT(data.item[itemText]).substr(0, 1)
                      : ""
                  }}
                </span>
              </v-avatar>
              <!-- 人员信息 -->
              <div>
                <div class="d-flex">
                  <span
                    style="font-size: 16px; color: rgba(0, 0, 0, 0.87)"
                    class="text-body-s"
                  >
                    {{ INT(data.item[itemText]) }}
                    <span class="text--secondary text-body-s">
                      {{
                        INT(data.item[staffCode])
                          ? "(" + INT(data.item[staffCode]) + ")"
                          : ""
                      }}
                    </span>
                  </span>
                  <span
                    class="text--secondary"
                    style="position: absolute; right: 16px; top: 10px"
                  >
                  </span>
                </div>
                <div class="d-flex" style="max-width: 30vw">
                  <span class="text--secondary">
                    {{ INT(data.item[job_post_name]) }}
                  </span>
                  <!-- <div style="font-size: 12px;color: rgba(0, 0, 0, 0.38);"
                       class="overflow">
                    {{ INT(data.item[job_post_name]) }}
                    {{
                      INT(data.item[job_grade_name])
                        ? "(" + INT(data.item[job_grade_name]) + ")"
                        : ""
                    }}
                  </div> -->
                  <!-- <div class="mx-2"></div> -->
                  <!-- <div style="font-size: 12px;color: rgba(0, 0, 0, 0.38);flex:1;"
                       class="overflow">
                    {{ INT(data.item[client_name]) }}
                    {{
                      INT(data.item[client_name]) &&
                      INT(data.item[org_level_name])
                        ? ">"
                        : ""
                    }}
                    {{ INT(data.item[org_level_name]) }}
                    {{
                      INT(data.item[org_level_name]) &&
                      INT(data.item[dept_name])
                        ? ">"
                        : ""
                    }}
                    {{ INT(data.item[dept_name]) }}
                  </div> -->
                </div>
              </div>
            </div>
          </v-list-item-content>
          <v-list-item-content
            style="height: 48px; border-bottom: 1px solid rgb(224, 224, 224)"
            class="pa-0"
            v-if="multiple && data.item.allcheck"
          >
            <div class="px-4" @click.stop="allcheck">
              <v-checkbox
                class="pt-4"
                :label="$t('label_select_all')"
                :on-icon="
                  statusCheck == 'indeterminate'
                    ? '$checkboxIndeterminate'
                    : '$checkboxOn'
                "
                readonly
                v-model="statusCheck"
              >
              </v-checkbox>
            </div>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
/**
 * 单选多选人员组件 AutoComplete
 *   <!-- filter:状态码 不传返所有  状态：0准备入职   1试用   2准备转正   3在职   4停职   5准备离职   6离职   7退休 -->
 * 
 * job_post_uuid
 * job_post_grade_uuid
 * dept_uuid
 * client_uuid
 * org_level_uuid
 *  job_post_name='job_post_uuid'
    job_grade_name='job_post_grade_uuid'
    client_name='dept_uuid'
    org_level_name='client_uuid'
    dept_name='org_level_uuid'
 */
import { get_dict_name } from "@/service/api/data_dictionary";
import { getBusinessList } from "@/service/api/prompt";
import { getStaffListForFilter } from "@/service/api/autoComplete.js";
export default {
  components: {},
  props: {
    maxHeight: {
      type: [String, Number],
      default: 304,
    },
    errorMessages: {},
    propertylist: {
      //内容前的数据
      type: Array,
    },
    propertyKey: {
      type: String,
      default: "property",
    },
    label: {},
    placeholder: {},
    backgroundColor: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    dropDownList: {
      type: Array,
    },
    staffUuid: {
      type: String,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    staffCode: {
      //员工id
      type: String,
      default: "staff_code",
    },
    itemText: {
      type: String,
      default: "show_name",
    },
    itemValue: {
      type: String,
      default: "uuid",
    },
    // staff_id: {
    //   type: String,
    //   default: 'staff_id'
    // },
    job_post_name: {
      //岗位名称
      type: String,
      default: "job_post_name",
    },
    job_grade_name: {
      //岗位等级名称
      type: String,
      default: "job_grade_name",
    },
    client_name: {
      //客户名称
      type: String,
      default: "client_name",
    },
    org_level_name: {
      //单位名称
      type: String,
      default: "org_level_all",
    },
    dept_name: {
      //部门名称
      type: String,
      default: "dept_name",
    },
    staff_avatar: {
      //图片地址
      type: [String, Object],
    },
    filter: {
      //请求过滤条件 默认为空
      type: String,
    },
    defaultRequest: {
      type: Boolean,
      default: false,
    },
    prompt_name: {
      type: [String, Object],
    },
    keyValues: {
      type: String,
      default: null,
    },
    itemHeight: {
      type: String,
      default: "48",
    },
  },
  model: {
    prop: "staffUuid",
    event: "changeStaff",
  },
  data() {
    return {
      // '#934CEO',
      colorArr: [
        "#637A88",
        "#3F9B30",
        "#289DAA",
        "#66B4E7",
        "#4354B4",
        "#7C81FC",
        "rgb(147, 76, 14)",
        "#AA3E90",
        "#FC8282",
        "#AA3E3E",
        "#ED7217",
        "#DBB016",
      ],
      randomcolor: null,
      uuid: [],
      autoUpdate: true,
      isUpdating: false,
      selectList: [],
      color: false,
      icon: false,
    };
  },
  filters: {
    replaceclient_and_org(val) {
      if (!val) return "";
      // return val.replaceAll('\\', '>').replaceAll('/', '>')
      return String(val).replace(/\//g, ">");
    },
  },
  computed: {
    statusCheck() {
      let uuidLength = this.staffUuid
        ? this.staffUuid.indexOf(",") != -1
          ? this.staffUuid.split(",").length
          : this.staffUuid
          ? 1
          : 0
        : 0;
      let length = this.selectList.length - 1;
      // console.log(this.selectList, this.staffUuid);
      // console.log(uuidLength, length);
      if (uuidLength == length) return true;
      else if (uuidLength > 0) return "indeterminate";
      else return false;
    },
  },
  async created() {
    // this.randomcolor = Math.round(Math.random() * (this.colorArr.length - 1))
    if (!this.prompt_name) {
      if (this.defaultRequest) {
        const res = await getStaffListForFilter({
          key: this.itemValue,
          value: this.staffUuid,
          filter: this.filter,
          org_level_uuid: this.$store.state.currentCompany,
        });
        let colorId = -1;
        if (res.code == 200) {
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.selectList = res.data.map((item) => {
              colorId++;
              if (colorId > this.colorArr.length - 1) colorId = 0;
              return {
                ...item,
                [this.itemValue]: String(item[this.itemValue]),
                colorId,
              };
            });
            if (this.selectList.length > 1 && this.multiple) {
              this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
            }
          } else {
            this.selectList = [];
          }
        }
      } else {
        let colorId = -1;
        if (Array.isArray(this.dropDownList) && this.dropDownList.length > 0) {
          this.selectList = this.dropDownList.map((item) => {
            colorId++;
            if (colorId > this.colorArr.length - 1) colorId = 0;
            return {
              ...item,
              [this.itemValue]: String(item[this.itemValue]),
              colorId,
            };
          });
          if (this.selectList.length > 1 && this.multiple) {
            this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
          }
        } else {
          this.selectList = [];
        }
      }
    } else {
      let obj = {};
      if (typeof this.prompt_name == "string")
        obj = { prompt_name: this.prompt_name };
      if (typeof this.prompt_name == "object") obj = this.prompt_name;
      const res = await getBusinessList(obj);
      if (res.code == 200) {
        let colorId = -1;
        if (Array.isArray(res.data) && res.data.length > 0) {
          this.selectList = res.data.map((item) => {
            colorId++;
            if (colorId > this.colorArr.length - 1) colorId = 0;
            return { ...item, colorId };
          });
          if (this.selectList.length > 1 && this.multiple) {
            this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
          }
        } else {
          this.selectList = [];
        }
      }
    }
  },
  watch: {
    keyValues: {
      async handler(v) {
        // console.log(v)
        const res = await getStaffListForFilter({
          v,
          filter: this.filter,
          org_level_uuid: this.$store.state.currentCompany,
        });
        if (res.code == 200) {
          let colorId = -1;
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.selectList = res.data.map((item) => {
              colorId++;
              if (colorId > this.colorArr.length - 1) colorId = 0;
              return {
                ...item,
                [this.itemValue]: String(item[this.itemValue]),
                colorId,
              };
            });
            if (this.selectList.length > 1 && this.multiple) {
              this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
            }
          } else {
            this.selectList = [];
          }
        }
      },
      deep: true,
    },
    selectList: {
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          this.change(this.uuid);
        }
      },
      deep: true,
    },
    prompt_name: {
      async handler(val) {
        if (val) {
          let obj = {};
          if (typeof val == "string") obj = { prompt_name: val };
          if (typeof val == "object") obj = val;
          const res = await getBusinessList(obj);
          if (res.code == 200) {
            let colorId = -1;
            if (Array.isArray(res.data) && res.data.length > 0) {
              this.selectList = res.data.map((item) => {
                colorId++;
                if (colorId > this.colorArr.length - 1) colorId = 0;
                return { ...item, colorId };
              });
              if (this.selectList.length > 1 && this.multiple) {
                this.selectList = [
                  { allcheck: "allcheck" },
                  ...this.selectList,
                ];
              }
            } else {
              this.selectList = [];
            }
          }
        }
      },
    },
    dropDownList: {
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          let colorId = -1;
          this.selectList = val.map((item) => {
            colorId++;
            if (colorId > this.colorArr.length - 1) colorId = 0;
            return {
              ...item,
              [this.itemValue]: String(item[this.itemValue]),
              colorId,
            };
          });
          if (this.selectList.length > 1 && this.multiple) {
            this.selectList = [{ allcheck: "allcheck" }, ...this.selectList];
          }
        } else {
          this.selectList = [];
        }
        this.change(this.uuid);
      },
      deep: true,
    },
    staffUuid: {
      handler(val) {
        if (this.multiple) {
          if (val == "" || val == undefined) return (this.uuid = []);
          // val.indexOf(',') != -1 ? this.uuid = val.split(',') : [val]
          val.indexOf(",") != -1
            ? (this.uuid = this.$set(this, "uuid", val.split(",")))
            : this.$set(this, "uuid", [val]);
        } else {
          this.uuid = val;
        }
        this.change(this.uuid);
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.multiple) {
      if (this.staffUuid != "" && this.staffUuid != undefined) {
        this.uuid =
          this.staffUuid.indexOf(",") != -1
            ? (this.uuid = this.staffUuid.split(","))
            : this.staffUuid
            ? [this.staffUuid]
            : [];
      }
    } else {
      this.uuid = this.staffUuid;
    }
    this.change(this.uuid);
  },
  methods: {
    removestar(v) {
      return String(v).replace("*", "");
    },
    closeChipProperty(val, val2) {
      this.$emit("closeChipProperty", val, val2);
    },
    blur() {
      this.color = false;
    },
    focus() {
      this.color = true;
    },
    allcheck() {
      let arr = this.$clone(this.selectList);
      // console.log(this.statusCheck, !this.statusCheck);
      if (!this.statusCheck || this.statusCheck == "indeterminate") {
        let uuids = [];
        arr.splice(0, 1);
        arr.forEach((item) => {
          uuids.push(item[this.itemValue]);
        });
        this.$nextTick(() => {
          this.$emit("changeStaff", uuids.join());
          this.$emit("changeStaffList", this.selectList);
        });
      } else {
        this.$nextTick(() => {
          this.$emit("changeStaff", "");
          this.$emit("changeStaffList", []);
        });
      }
      // let uuids = []
      // arr.splice(0, 1)
      // arr.forEach((item) => {
      //   uuids.push(item.uuid)
      // })
      // this.$emit("changeStaff", uuids.join())
    },
    getImgSrc(val) {
      if (typeof val == "object") return val.path;
      if (val == "" || val == undefined) return "";
      else return val;
      // findSrc({ uuid: val }).then((res) => {
      //   if (res.data.files.length > 0) {
      //     return res.data.files[0].path
      //   } else {
      //     return ''
      //   }
      // })
    },
    filterMethod(item, queryText) {
      if (queryText) {
        if (!this.INT(item[this.itemText])) return false;

        const textOne = this.INT(item[this.itemText]).toLowerCase();

        const textTwo = this.INT(item[this.staffCode])
          ? this.INT(item[this.staffCode]).toLowerCase()
          : "";

        const searchText = String(queryText).toLowerCase();

        return (
          textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
        );
      }
    },
    change(val) {
      if (this.multiple) {
        let arr = this.$clone(this.uuid);
        let arr2 = [];
        if (Array.isArray(arr) && arr.length > 0) {
          this.selectList.forEach((item) => {
            let isno = false;
            arr.forEach((item1) => {
              if (item[this.itemValue] == item1) {
                isno = true;
                return;
              }
            });
            if (isno) {
              arr2.push(item);
            }
          });
        }
        this.$emit("changeStaffList", arr2);
        this.$emit(
          "changeStaff",
          Array.isArray(this.uuid) && this.uuid.length > 0
            ? this.uuid.join()
            : ""
        );
      } else {
        this.$emit("changeStaff", val ? val : "");
        this.selectList.forEach((item) => {
          if (item[this.itemValue] == val) {
            this.$emit("changeStaffList", item);
          }
        });
      }
    },
    remove(item) {
      if (this.multiple) {
        const index = this.uuid.indexOf(item[this.itemValue]);
        if (index >= 0) this.uuid.splice(index, 1);
        let arr = this.$clone(this.uuid);
        let arr2 = [];
        if (Array.isArray(arr) && arr.length > 0) {
          this.selectList.forEach((item) => {
            let isno = false;
            arr.forEach((item1) => {
              if (item[this.itemValue] == item1) {
                isno = true;
                return;
              }
            });
            if (isno) {
              arr2.push(item);
            }
          });
        }
        this.$emit("changeStaffList", arr2);
        this.$emit("changeStaff", this.uuid.length > 0 ? this.uuid.join() : "");
      } else {
        this.uuid = "";
        this.$emit("changeStaff", this.uuid);
      }
    },
  },
};
</script>

<style scoped>
/* /deep/ .v-select__slot {
  min-height: 40px;
} */
.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
/deep/ .v-list-item {
  height: 48px;
  padding: 0;
}
/deep/ .v-select__selections {
  min-height: 40px;
  padding-left: 8px;
}
/deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}

.autoocomplete /deep/ .v-label {
  top: 2px !important;
  left: -5px !important;
}
.overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
